import GuestGuard from "../components/GuestGuard";
import ProjectTasksPage from "./ProjectTasksPage";

export default function GuestProjectTasksPage() {
  return (
    <GuestGuard>
      <ProjectTasksPage />
    </GuestGuard>
  );
}

